import { Route, Routes } from "react-router-dom";
import { AuthCallback } from "./AuthCallback";
import { AuthLogin } from "./AuthLogin";
import { AuthLogout } from "./AuthLogout";

/**
 * Auth routes component that handles OAuth flow
 * Handles /oauth/login, /oauth/callback, /oauth/logout
 */
export const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<AuthLogin />} />
      <Route path="/callback" element={<AuthCallback />} />
      <Route path="/logout" element={<AuthLogout />} />
    </Routes>
  );
};

export default AuthRoutes;
